import axios from 'axios';
import {
  authRequest,
  authResponseFailed,
  authResponseSuccess
} from 'utils/interceptors/auth.interceptor';

const ApiInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  crossDomain: true,
  crossOrigin: true,
  timeout: 180000,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=utf-8'
  },
  withCredentials: true
});

ApiInstance.interceptors.request.use(authRequest);

ApiInstance.interceptors.response.use(authResponseSuccess, authResponseFailed);

export default ApiInstance;
